export const GET_SUSPENDED_REASONS = gql`
    query suspendedReasons($filter: FilterSuspendedReasonsInput) {
        suspendedReasons(filter: $filter) {
            id
            description
            status
            createdAt
        }
    }
`;
